module.exports = __webpack_public_path__ + "static/media/Depth-First-Search.0b83cd5b.gif";